import React, { useState } from "react";
import {
  Typography,
  Box,
  Stack,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";

import LineChartMonitoring from "../../components/LineChartMonitoring";

import ModalDialogs from "../../components/ModalDialogs";

import { FieldInputText, FieldSelect } from "../../components/Fields";

import "./styles.css";
import { dataColor } from "./checkData";

const styles = {
  checkboxText: {
    fontFamily: "Nunito",
    color: "#063f5e",
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "22px",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
    boxSizing: "border-box !important",
    gap: "16px",
  },
};

const FieldCheckbox = ({ checked, onChange, label }) => (
  <FormControlLabel
    control={
      <Checkbox
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
    }
    label={<Typography style={styles.checkboxText}>{label}</Typography>}
  />
);

const RenderGroupFields = ({
  show,
  color,
  position,
  label,
  baseObject,
  onChange,
}) => {
  return (
    <>
      <FieldCheckbox
        label={label}
        checked={baseObject[show]}
        onChange={(val) => onChange(show, val)}
      />
      <FieldInputText
        label=""
        placeholder="Valor"
        type="number"
        value={baseObject[position]}
        setValue={(value) => {
          onChange(position, value);
        }}
        disabled={!baseObject[show]}
      />
      <FieldSelect
        label=""
        value={baseObject[color]}
        setValue={(value) =>
          onChange(color, value === "" ? dataColor[0].id : value)
        }
        items={dataColor}
        disabled={!baseObject[show]}
      />
    </>
  );
};

function DetailModal(props) {
  const { openModal, setOpenModal, data, sensor } = props;

  const [configGraphic, setConfigGraphic] = useState({
    lineStrokeWidth: 1,
    keyYAxisShow: false,
    gridVertical: false,
    gridHorizontal: false,
    sensor: "",
    graficType: "Linha",
    //ponto central
    refCenterShow: false,
    refCenterPosition: 0,
    refCenterColor: dataColor[0].id,
    //ponto max
    refMaxShow: false,
    refMaxPosition: 0,
    refMaxColor: dataColor[1].id,
    //ponto min
    refMinShow: false,
    refMinPosition: 0,
    refMinColor: dataColor[2].id,
  });

  function handleChangeConfigGraphic(field, value) {
    setConfigGraphic((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  }

  return (
    <ModalDialogs
      open={openModal}
      onClose={() => setOpenModal(false)}
      title={`Visualização detalhada ${sensor}`}
      maxWidth="900px"
      body={
        <Stack width={{ xs: "330px", sm: "550px", md: "850px" }} padding={1}>
          <Accordion
            sx={{ marginBottom: "16px" }}
            className="AccordionContainer"
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
              sx={{ color: "#063f5e" }}
            >
              <FilterAltOutlinedIcon
                sx={{ marginTop: "3px", stroke: "#063f5e" }}
              />
              Filtros
            </AccordionSummary>
            <AccordionDetails>
              <Stack gap="16px">
                <Divider />
                <Stack textAlign="start">
                  <Typography
                    style={{ ...styles.checkboxText, fontSize: "17px" }}
                  >
                    Grade
                  </Typography>
                  <FormGroup sx={styles.grid}>
                    <FieldCheckbox
                      label="Grade vertical"
                      checked={configGraphic.gridVertical}
                      onChange={(val) =>
                        handleChangeConfigGraphic("gridVertical", val)
                      }
                    />
                    <FieldCheckbox
                      label="Grade horizontal"
                      checked={configGraphic.gridHorizontal}
                      onChange={(val) =>
                        handleChangeConfigGraphic("gridHorizontal", val)
                      }
                    />

                    <Box></Box>
                    <Box></Box>
                  </FormGroup>
                </Stack>

                <Divider />

                <Stack textAlign="start">
                  <Typography
                    style={{ ...styles.checkboxText, fontSize: "17px" }}
                  >
                    Eixo
                  </Typography>
                  <FormGroup sx={{ ...styles.grid, alignItems: "self-start" }}>
                    <FieldCheckbox
                      label="Mostrar eixos"
                      checked={configGraphic.keyYAxisShow}
                      onChange={(val) =>
                        handleChangeConfigGraphic("keyYAxisShow", val)
                      }
                    />

                    <Stack textAlign="start">
                      <RenderGroupFields
                        label="Eixo central"
                        show="refCenterShow"
                        position="refCenterPosition"
                        color="refCenterColor"
                        baseObject={configGraphic}
                        onChange={handleChangeConfigGraphic}
                      />
                    </Stack>
                    <Stack textAlign="start">
                      <RenderGroupFields
                        label="Eixo mínimo"
                        show="refMinShow"
                        position="refMinPosition"
                        color="refMinColor"
                        baseObject={configGraphic}
                        onChange={handleChangeConfigGraphic}
                      />
                    </Stack>
                    <Stack textAlign="start">
                      <RenderGroupFields
                        label="Eixo máximo"
                        show="refMaxShow"
                        position="refMaxPosition"
                        color="refMaxColor"
                        baseObject={configGraphic}
                        onChange={handleChangeConfigGraphic}
                      />
                    </Stack>
                  </FormGroup>
                </Stack>

                <Divider />

                <Stack textAlign="start">
                  <Typography
                    style={{ ...styles.checkboxText, fontSize: "17px" }}
                  >
                    Mais
                  </Typography>
                  <Box
                    sx={{ ...styles.grid, marginTop: 2, textAlign: "start" }}
                  >
                    <FieldSelect
                      label="Espessura da linha"
                      value={configGraphic.lineStrokeWidth}
                      setValue={(value) =>
                        handleChangeConfigGraphic(
                          "lineStrokeWidth",
                          value === "" ? 1 : value
                        )
                      }
                      items={[1, 2, 3, 4].map((value) => {
                        return { id: value, label: value };
                      })}
                    />
                    <FieldSelect
                      label="Tipo do gráfico"
                      value={configGraphic.graficType}
                      setValue={(value) =>
                        handleChangeConfigGraphic(
                          "graficType",
                          value === "" ? "Linha" : value
                        )
                      }
                      items={["Linha", "Barras"].map((value) => {
                        return { id: value, label: value };
                      })}
                    />

                    <Box></Box>
                    <Box></Box>
                  </Box>
                </Stack>
              </Stack>
            </AccordionDetails>
          </Accordion>

          <Typography variant="h5" fontWeight="600" mb="16px">
            Gráfico
          </Typography>

          <LineChartMonitoring
            data={data}
            KeyXAxis="date"
            KeyYAxis="value"
            lineColor="#063F5E"
            height={400}
            KeyYAxisShow={configGraphic.keyYAxisShow}
            GridVertical={configGraphic.gridVertical}
            GridHorizontal={configGraphic.gridHorizontal}
            lineStrokeWidth={parseInt(configGraphic.lineStrokeWidth)}
            brushShow={true}
            graficType={configGraphic.graficType}
            refCenterShow={configGraphic.refCenterShow}
            refCenterPosition={configGraphic.refCenterPosition}
            refCenterColor={configGraphic.refCenterColor}
            refMaxShow={configGraphic.refMaxShow}
            refMaxPosition={configGraphic.refMaxPosition}
            refMaxColor={configGraphic.refMaxColor}
            refMinShow={configGraphic.refMinShow}
            refMinPosition={configGraphic.refMinPosition}
            refMinColor={configGraphic.refMinColor}
          />
        </Stack>
      }
      onActionSecondary={() => setOpenModal(false)}
      secondaryButtonText="Fechar"
    />
  );
}

export function arePropsEqualDetailModal(prevProps, nextProps) {
  if (
    prevProps.openModal === nextProps.openModal &&
    prevProps.data === nextProps.data
  ) {
    return true;
  }

  return false;
}

export default React.memo(DetailModal, arePropsEqualDetailModal);
